/*
 *******************************************************************************
 *
 *  Filename:   ./agents/agentListGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for ListGroups API endpoints.
 *
 *  Author:     Norman J. Nolasco [ Archetact ]
 *
 *  Created:    Saturday, August 27, 2022 - 09:05:11 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *
 *
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests'

export const ListGroups = {
  all: () =>
    requests.postLambda('/listGroups', {
      action: 'getListItems',
      parameters: {
        listid: 67,
        parentid: 0,
        order: 'ORDERID ASC',
      },
    }),
}
